import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import metaOverrideSet from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/MetaOverrideSet';
import ScenarioSelectionRedefinedWrapperTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate';
import ScenarioSelectionRedefinedScenarioDetailsContent from './Content';

const ScenarioSelectionRedefinedScenarioDetailsStepTemplate = ({
  resource,
}) => {
  return (
    <ScenarioSelectionRedefinedWrapperTemplate
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      layout={ScenarioSelectionRedefinedScenarioDetailsContent}
    />
  );
};

ScenarioSelectionRedefinedScenarioDetailsStepTemplate.defaultProps = {
};

ScenarioSelectionRedefinedScenarioDetailsStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default ScenarioSelectionRedefinedScenarioDetailsStepTemplate;
